import CurrentQR from "Components/CurrentQR";
import IconButton from "Components/IconButton";
import StudentRenderer from "Components/ModelRenderers/StudentRenderer";
import MyBrand from "Components/MyBrand";
import MyLoadingSpinner from "Components/MyLoadingSpinner";
import { STAR_HOLLOW } from "Constants/Common";
import useSchaleStudents from "Hooks/useStudents";
import IStyle from "Interfaces/IStyle";
import { useToast } from "Layouts/Toast";
import Student, { SchaleStudent } from "Models/Student";
import { copyToClipboard } from "Utils/Common";
import domToImage from 'dom-to-image';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Accordion, Alert, Button, Col, Form, Nav, NavDropdown, Row } from "react-bootstrap";
import AccordionBody from "react-bootstrap/esm/AccordionBody";
import AccordionHeader from "react-bootstrap/esm/AccordionHeader";
import { useSearchParams } from "react-router-dom";

const BASE66_DIGITS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_.~";

const styles:IStyle = {
	cardContainer: {
		display: "flex", 
		flexDirection: "row", 
		flexWrap: "wrap"
	},
	container: {
		padding: 10,
		margin: 5,
		border: "1px solid",
		// borderColor: "violet",
		borderRadius: 20,
		borderColor: "pink",
	},
	cardGroup: {
		margin: "1em",
		zIndex: 1,
		padding: "0 0.3em 0 0.3em",
		border: "1px solid",
		borderColor: "pink",
	},
	compactCardGroup: {
		margin: "1em 1em 0.1em 1em",
		zIndex: 1,
		padding: "0 0.3em 0 0.3em",
	},
	card: {
		textAlign: "center",
		display: "block",
		// margin: "auto",
		marginBottom: "auto",
		marginLeft: "auto",
		marginRight: "auto",
		// verticalAlign: "top"
	},
	spinnerRow: {
		// alignContent: "center",
		// alignItems: "center",
		// alignSelf: "center",
		// textAlign: "center"
		zIndex: 10
	},
	button: {
		marginRight: 5
	},
	buttonLink: {
		margin: 5,
	},
	selectButton: {
		marginRight: "1em",
		padding: "0.3em"
	},
	input: {
		marginRight: "2em"
	},
	flexGroup: {
		display: "flex",
		flexWrap: "wrap"
	},
}

function toBaseN(num: bigint|number, b: number):string {
	if (num == null || typeof(num) === "undefined")
		return null;
	if (typeof(num) === "number")
		num = BigInt(num);
	if (b <= 0 || b > 66)
		throw new Error("Unsupported base");
	const base = BigInt(b);
  
	if (num === 0n) {
	  return "0";
	}
  
	const result = [];
	while (num > 0n) {
	  const remainder = num % base;
	  result.unshift(BASE66_DIGITS[Number(remainder)]);
	  num = num / base;
	}
  
	return result.join("");
}

function fromBaseN(base66String: string, b: number): bigint {
	if (base66String == null || typeof(base66String) === "undefined")
		return null;
	if (b <= 0 || b > 66)
		throw new Error("Unsupported base");
	const base = BigInt(b);
	let result = 0n;
	let power = BigInt(base66String.length - 1);
  
	for (const char of base66String) {
	  const index = BigInt(BASE66_DIGITS.indexOf(char));
	  if (index === -1n || index >= base) {
		throw new Error(`Invalid base${b} character`);
	  }
	  result += index * (base ** power);
	  power--;
	}
  
	return result;
  }
function toBase66(num: bigint|number):string {
	if (typeof(num) === "number")
		num = BigInt(num);
	const base:bigint = 66n;
  
	if (num === 0n) {
	  return "0";
	}
  
	const result = [];
	while (num > 0n) {
	  const remainder = num % base;
	  result.unshift(BASE66_DIGITS[Number(remainder)]);
	  num = num / base;
	}
  
	return result.join("");
}

function fromBase66(base66String: string): bigint {
	if (base66String == null || typeof(base66String) === "undefined")
		return null;
	const base:bigint = 66n;
  
	let result = 0n;
	let power = BigInt(base66String.length - 1);
  
	for (const char of base66String) {
	  const index = BigInt(BASE66_DIGITS.indexOf(char));
	  if (index === -1n) {
		throw new Error("Invalid base66 character");
	  }
	  result += index * (base ** power);
	  power--;
	}
  
	return result;
}

export enum STATE {
	UNSELECTED = "0",
	SELECTED = "1",
	BLUE = "2",
	BLACK = "3",
}

export namespace STATE {
	export function next(state:STATE) {
		switch (state) {
			case STATE.UNSELECTED:
				return STATE.SELECTED;
			case STATE.SELECTED:
				return STATE.UNSELECTED;
		}

		return STATE.UNSELECTED;
	}

	export function getName(state:STATE) {
		switch (state) {
			case STATE.UNSELECTED:
				return "UNSELECTED";
			case STATE.SELECTED:
				return "SELECTED";
			case STATE.BLUE:
				return "BLUE";
				// return "HIGHLIGHTED";
			case STATE.BLACK:
				return "BLACK";
		}
		
		return "SECRET";
	}
	
	export function getColor(state:STATE) {
		switch (state) {
			case STATE.UNSELECTED:
				return "bg-violet-transparent-70";
			case STATE.SELECTED:
				return "bg-violet-transparent-70";
			case STATE.BLUE:
				return "bg-blue-transparent-70";
				// return "HIGHLIGHTED";
			case STATE.BLACK:
				return "bg-black-transparent-70";
		}

	}

	export function getAll() {
		return [
			STATE.UNSELECTED,
			STATE.SELECTED,
			STATE.BLUE,
			STATE.BLACK,
		]
	}


}
const BASE = 5;

const DEFAULT_TITLE = "ROSTER";
const DEFAULT_UNSELECTED = "";
const DEFAULT_PINK = "";
const DEFAULT_BLUE = "";
const DEFAULT_BLACK = "";
const STATES = STATE.getAll();
const MYSTICS = [1, 2, 3]
const FORMATION = ["Striker", "Special"]

const KEYS = {
	SAVES: "midokuni.tool.roster.saves",
}
type SORT_BY = "Release" | "Name" | "ID";
type GROUP_BY = "None" | "Availability" | "Mystic" | "Role" | "Formation" | "State" | "Bullet" | "Armor";
function getSorter(sort_by: SORT_BY):( a: SchaleStudent, b: SchaleStudent ) => number {
	switch (sort_by) {
		case "Release":	return (a, b) => a.DefaultOrder - b.DefaultOrder;
		case "Name": return (a, b) => a.Name.localeCompare(b.Name);
		case "ID":	return (a, b) => a.Id - b.Id;
	}
	return (a, b) => a.DefaultOrder - b.DefaultOrder;
}


const getStudentParamsUpdater = (studentState: string[], paramKey: string) => {
	return (params:URLSearchParams) => {
		if(studentState) {
			const str = toBase66(fromBaseN([...studentState].reverse().join(""), BASE));
			if (str !== "0") {
				params.set(paramKey, str)
			} else {
				params.delete(paramKey)
			}
		}
		return params;
	};
};
export default function Roster() {
	const [searchParams, setSearchParams] = useSearchParams();
	const fStates = searchParams.getAll("fState");
	const [filterStatus, setFilterStatus] = useState<STATE[]>(fStates.length > 0 ? fStates.map(f => f as STATE) : STATES);
	const [filterMystic, setFilterMystic] = useState(MYSTICS);
	const [filterAtk, setFilterAtk] = useState([]);
	const [filterDef, setFilterDef] = useState([]);
	const [autoUpdateStudentState, setAutoUpdateStudentState] = useState(true);
	const [filterTactic, setFilterTactic] = useState([]);
	const [sortBy, setSortBy] = useState<SORT_BY>("Release");
	const [groupBy, setGroupBy] = useState<GROUP_BY>("None");
	const calculateStudentQueryParams = () => {
		const studentStates:[string[], string][] = [[s10, "s10"],
		[s13, "s13"],
		[s16, "s16"],
		[s20, "s20"],
		[s23, "s23"],
		[s26, "s26"],
		[s30, "s30"],
		[s33, "s33"],
		[s36, "s36"]];
		for (const pair of studentStates) {
			setSearchParams(getStudentParamsUpdater(pair[0], pair[1]));
		}
	}
	const [saves, _setSaves] = useState<{[key: string]: string}>(localStorage.getItem(KEYS.SAVES) ? JSON.parse(localStorage.getItem(KEYS.SAVES)) : {
		"Hina": "s10=1aYsnxxo_pdXbuBTVXinN1ECAbZ7CRFIaD&title=Hina"
	});
	const setSaves = (newSaves:{[key: string]: string}) => {
		_setSaves(newSaves);
		localStorage.setItem(KEYS.SAVES, JSON.stringify(newSaves));
	}

	const {
		isReady,
		schaleStudent,
		BULLETS,
		ARMORS,
		TACTICS,
	} = useSchaleStudents((result)=>{
		setFilterAtk([...new Set(result.map(s=>s.BulletType))].sort());
		setFilterDef([...new Set(result.map(s=>s.ArmorType))].sort());
		setFilterTactic([...new Set(result.map(s=>s.TacticRole))].sort());
	});
	
	const [title, setTitle] = useState(searchParams.get("title") ?? DEFAULT_TITLE);
	const [noteUnselected, setNoteUnselected] = useState(searchParams.get("note_uns") ?? DEFAULT_UNSELECTED);
	const [notePink, setNotePink] = useState(searchParams.get("note_pin") ?? DEFAULT_PINK);
	const [noteBlue, setNoteBlue] = useState(searchParams.get("note_blu") ?? DEFAULT_BLUE);
	const [noteBlack, setNoteBlack] = useState(searchParams.get("note_blk") ?? DEFAULT_BLACK);
	const { addToast } = useToast()
	const rosterDiv = useRef(null);
	// console.log(toBase66(fromBaseN("2222222222", 3)))
	const [filterFormation, setFilterFormation] = useState(FORMATION);
	const [s10, setS10] = useState(([...(toBaseN(fromBase66(searchParams.get("s10")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s13, setS13] = useState(([...(toBaseN(fromBase66(searchParams.get("s13")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s16, setS16] = useState(([...(toBaseN(fromBase66(searchParams.get("s16")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s20, setS20] = useState(([...(toBaseN(fromBase66(searchParams.get("s20")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s23, setS23] = useState(([...(toBaseN(fromBase66(searchParams.get("s23")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s26, setS26] = useState(([...(toBaseN(fromBase66(searchParams.get("s26")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s30, setS30] = useState(([...(toBaseN(fromBase66(searchParams.get("s30")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s33, setS33] = useState(([...(toBaseN(fromBase66(searchParams.get("s33")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	const [s36, setS36] = useState(([...(toBaseN(fromBase66(searchParams.get("s36")), BASE) ?? "").split("").reverse(), ..."0".repeat(200)]));
	function getStatus(studentId:string) {
		return getCategoryState(studentId)[parseInt(studentId.substring(2))] as STATE;
	}
	
	function groupStudents(students: SchaleStudent[], group_by: GROUP_BY): {[key: string]: SchaleStudent[]} {
		let key = "";
		const groups: {[key: string]: SchaleStudent[]} = {};
		let map = {};
		switch (group_by) {
			case "None": return {"": students};
			case "State": 
				for (const student of students) {
					const status = STATE.getName(getStatus(student.Id.toString()));
					if (!!!groups[status]) {
						groups[status] = [student];
					} else {
						groups[status].push(student);
					}
				}

				return groups;
			case "Mystic": key = 'StarGrade'; 
			map = {
				1: "1"+STAR_HOLLOW,
				2: "2"+STAR_HOLLOW,
				3: "3"+STAR_HOLLOW,
			}
			break;
			case "Role": key = 'TacticRole'; break;
			case "Formation": key = 'Formation'; break;
			case "Bullet": key = 'BulletType'; break;
			case "Armor": key = 'ArmorType'; break;
			case "Availability": key = 'IsLimited'; 
			map = {
				0: "Permanent",
				1: "Limited",
				2: "Welfare",
				3: "Fes",
				4: "Archive",
			}; break;
		}

		for (const student of students) {
			const groupKey = (function():string{
				if (Array.isArray(student[key]) && student[key].length === 3) {
					if (map[student[key][0]] === map[student[key][1]] && map[student[key][1]] === map[student[key][2]]) {
						return map[student[key][0]];
					}
					return `${map[student[key][0]]} (JP) / ${map[student[key][1]]} (Global) / ${map[student[key][2]]} (CN)`;
				}
				return map[student[key]] ?? student[key];
			})();

			if (!!!groups[groupKey]) {
				groups[groupKey] = [student];
			} else {
				groups[groupKey].push(student);
			}
		}

		return groups;
	}
	const display = useMemo(() => {
		return schaleStudent.filter(student => {
			if (filterStatus.indexOf(getStatus(student.Id.toString())) < 0)
				return false;
			if (filterMystic.indexOf(student.StarGrade) < 0)
				return false;
			if (filterAtk.indexOf(student.BulletType) < 0)
				return false;
			if (filterDef.indexOf(student.ArmorType) < 0)
				return false;
			if (filterTactic.indexOf(student.TacticRole) < 0)
				return false;
			if (!filterFormation.includes(student.Formation))
				return false;
			
			return true;
		}).sort(getSorter(sortBy));

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		schaleStudent,
		sortBy,
		filterStatus,
		filterMystic,
		filterAtk,
		filterDef,
		filterTactic,
		filterFormation,
		s10,
		s13,
		s16,
		s20,
		s23,
		s26,
		s30,
		s33,
		s36,
	]);
	const groups = useMemo(() => {
		const groups = groupStudents(display, groupBy);
		return groups;
	}, [display, groupBy]);
	useEffect(()=>{
		setSearchParams( params => {
			params.delete("fState")
			if (filterStatus.length < STATES.length) {
				for ( const fState of filterStatus) {
					params.append("fState", fState);
				}
			}
			return params;
		})
	},[filterStatus])
	const sanitizeSearchParam = (key:string, value:string, defaultValue:string) => (params:URLSearchParams) => {
		if(value?.length > 0 && value !== defaultValue) {
			params.set(key, value)
		} else {
			params.delete(key)
		}
		return params;
	}
	useEffect(()=>{setSearchParams( sanitizeSearchParam("title", title, DEFAULT_TITLE) )},[title])
	useEffect(()=>{setSearchParams( sanitizeSearchParam("note_uns", noteUnselected, DEFAULT_UNSELECTED) )},[noteUnselected])
	useEffect(()=>{setSearchParams( sanitizeSearchParam("note_pin", notePink, DEFAULT_PINK) )},[notePink])
	useEffect(()=>{setSearchParams( sanitizeSearchParam("note_blu", noteBlue, DEFAULT_BLUE) )},[noteBlue])
	useEffect(()=>{setSearchParams( sanitizeSearchParam("note_blk", noteBlack, DEFAULT_BLACK) )},[noteBlack])

	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s10, "s10"))},[s10,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s13, "s13"))},[s13,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s16, "s16"))},[s16,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s20, "s20"))},[s20,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s23, "s23"))},[s23,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s26, "s26"))},[s26,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s30, "s30"))},[s30,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s33, "s33"))},[s33,autoUpdateStudentState])
	useEffect(()=>{if(autoUpdateStudentState)setSearchParams(getStudentParamsUpdater(s36, "s36"))},[s36,autoUpdateStudentState])

	function getCategoryState(studentId:string) {
		switch (studentId.substring(0, 2)) {
			case "10": return s10;
			case "13": return s13;
			case "16": return s16;
			case "20": return s20;
			case "23": return s23;
			case "26": return s26;
			case "30": return s30;
			case "33": return s33;
			case "36": return s36;
		}

		return [];
	}
	function setCategoryState(studentId:string, val:string[]) {
		switch (studentId.substring(0, 2)) {
			case "10": return setS10(val);
			case "13": return setS13(val);
			case "16": return setS16(val);
			case "20": return setS20(val);
			case "23": return setS23(val);
			case "26": return setS26(val);
			case "30": return setS30(val);
			case "33": return setS33(val);
			case "36": return setS36(val);
		}
		return null;
	}


	function setStudentState(studentId:string, newState:STATE) {
		let state = getCategoryState(studentId);
		if (!state) return;
		const i = parseInt(studentId.substring(2));
		state[i] = newState.toString();
		setCategoryState(studentId, [...state]);
	}

	function toggleStudent(studentId:string) {
		let state = getCategoryState(studentId);
		if (!state) return;
		const i = parseInt(studentId.substring(2));
		setStudentState(studentId, STATE.next((state[i] as STATE)))
	}
	const [isPic, setIsPic]=useState(false);
	async function downloadImage() {
		setIsPic(true);
		try {
			const su = rosterDiv.current;
			const dataUrl = await domToImage.toPng(su);
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = title+'.png';
			link.click();
		} catch (error) {
			addToast('Error capturing image:'+error);
			console.error('Error capturing or copying image:', error);
		}
		setIsPic(false);
	}
	async function copyImage() {
		setIsPic(true);
		try {
			const su = rosterDiv.current;
			const dataUrl = await domToImage.toPng(su);
			const canvas:any = document.createElement('canvas');
			// console.log(su.parentElement.style.background)
			// canvas.bgcolor = "red"
			// canvas.bgcolor = window.getComputedStyle(su).getPropertyValue('--bs-body-bg')
			canvas.width = su.offsetWidth;
			canvas.height = su.offsetHeight;
			const ctx = canvas.getContext('2d');
			const img = new Image();
			img.src = dataUrl;
			img.onload = () => {
				ctx?.drawImage(img, 0, 0);
				canvas.toBlob(function(blob) { 
					const item = new ClipboardItem({ "image/png": blob });
					navigator.clipboard.write([item]); 
					addToast("Copied to clipboard");
				});
			};
		} catch (error) {
			addToast('Error capturing image:'+error);
			console.error('Error capturing or copying image:', error);
		}
		setIsPic(false);
	}
	
	const [contextMenuPos, setContextMenuPos] = useState({
		x: 0,
		y: 0
	})
	const [contextStudent, setContextStudent] = useState<SchaleStudent>(null)

	function StudentContextMenu() {
		if (!!!contextStudent) return null;
		return <Col className="show dropdown-menu z-top" style={{
			position: "absolute",
			top: contextMenuPos.y,
			 left: contextMenuPos.x
		}}>
			<NavDropdown.Item disabled={getStatus(contextStudent.Id.toString()) === STATE.SELECTED}>
				<Nav.Item onClick={()=>setStudentState(contextStudent.Id.toString(), STATE.SELECTED)} key="Select">Select</Nav.Item>
			</NavDropdown.Item>
			<NavDropdown.Item disabled={getStatus(contextStudent.Id.toString()) === STATE.UNSELECTED}>
				<Nav.Item onClick={()=>setStudentState(contextStudent.Id.toString(), STATE.UNSELECTED)} key="Deselect">Deselect</Nav.Item>
			</NavDropdown.Item>
			<NavDropdown.Item disabled={getStatus(contextStudent.Id.toString()) === STATE.BLUE}>
				<Nav.Item onClick={()=>setStudentState(contextStudent.Id.toString(), STATE.BLUE)} key="A">{STATE.getName(STATE.BLUE)}</Nav.Item>
			</NavDropdown.Item>
			<NavDropdown.Item disabled={getStatus(contextStudent.Id.toString()) === STATE.BLACK}>
				<Nav.Item onClick={()=>setStudentState(contextStudent.Id.toString(), STATE.BLACK)} key="B">{STATE.getName(STATE.BLACK)}</Nav.Item>
			</NavDropdown.Item>
			<NavDropdown.ItemText className="text-pink text-center" key="Name">{contextStudent.getDisplayName()}</NavDropdown.ItemText>
        </Col>
	}
	const card = document.querySelector(".student")?.getBoundingClientRect();
	const screenshotWidth = (card?.width ?? 0)*Math.min(16, Math.max(6, (Math.floor(Math.pow(display.length, 0.5)))));
	if (!isReady) return <MyLoadingSpinner isLoading={!isReady} />;

	return (<div onClick={()=>setContextStudent(null)}>
	<Row >
		<Col>
			<IconButton 
				image="/logo512.png"
				label="📷 Screenshot"
				onClick={async () => copyImage()}
			/>
		</Col>
		<Col>
			<IconButton 
				image="/logo512.png"
				label="📷 Download"
				onClick={async () => downloadImage()}
			/>
		</Col>
		<Col>
			<IconButton 
				image="/logo512.png"
				label="Share URL"
				onClick={async () => {
					if(!autoUpdateStudentState) {
						calculateStudentQueryParams();
					}
					const shareText = window.location.href;
					copyToClipboard(shareText);
					addToast("URL has put in your clipboard!")
				}}
			/>
		</Col>
	</Row>
	<Row  className="filters">
		<Col>
			<Accordion>
				<Accordion.Item eventKey="0">
					<AccordionHeader><h4>Settings</h4></AccordionHeader>
					<AccordionBody>
						<Row>
							<Col>
								<Form.Check 
								type="switch"
								id="auto-update"
								label="Automatically update URL when de/selecting students (Disable if you experience lagging)"
								checked={autoUpdateStudentState}
								onChange={(a)=>{
									setAutoUpdateStudentState(a.target.checked);
								}}
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								<label>Title</label>
								<input id="title-input" type="text" style={styles.input} maxLength={30} value={title} onChange={(e)=>setTitle(e.target.value)}></input>
							{/* </Col>
							<Col> */}
								<label>Load Saved State</label>
								<select style={styles.input}  id="save-select" value={Object.keys(saves).includes(title) ? title : ""} onChange={(e)=>{
									window.location.search = saves[e.target.value];
								}}>
									<option value="" disabled>Select State to Load</option>
									{Object.keys(saves).map((key)=><option id={`save_${key}`} key={key} value={key}>{key}</option>)}
								</select>
								<Button variant="violet" style={styles.selectButton} onClick={()=>{
									if (!autoUpdateStudentState) calculateStudentQueryParams();
									const newSaves = {
										...saves,
										[title]: window.location.search
									};
									setSaves(newSaves);
									addToast(`Saved current state as "${title}"`);
								}}>Save State</Button>
								<Button variant="danger" style={styles.selectButton} disabled={!Object.keys(saves).includes(title)} onClick={()=>{
									const newSaves = {
										...saves,
									};
									delete newSaves[title];
									setSaves(newSaves);
									addToast(`Deleted state "${title}"`);
								}}>Delete State</Button>
							</Col>
						</Row>
						<Row><Col><h5 className="text-pink">Notes</h5></Col></Row>
						<Row>
							<Col>
								<label>Unselected</label>
								<input id="unselected-input" style={styles.input} type="text" maxLength={30} value={noteUnselected} onChange={(e)=>setNoteUnselected(e.target.value)}></input>
								<label>Pink</label>
								<input id="pink-input" style={styles.input} type="text" maxLength={30} value={notePink} onChange={(e)=>setNotePink(e.target.value)}></input>
								<label>Blue</label>
								<input id="blue-input" style={styles.input} type="text" maxLength={30} value={noteBlue} onChange={(e)=>setNoteBlue(e.target.value)}></input>
								<label>Black</label>
								<input id="black-input" style={styles.input} type="text" maxLength={30} value={noteBlack} onChange={(e)=>setNoteBlack(e.target.value)}></input>
							</Col>
						</Row>
						<Row><Col><h5 className="text-pink">Filters</h5></Col></Row>
						<Row style={styles.filterRow}>
							<Col xs={12}>
								<label>State [Persistent]</label>
							</Col>
						</Row>
						<Row>
							<Col style={styles.flexGroup}><Form.Check // prettier-ignore
								checked={filterStatus.length > 0}
								style={styles.input}
								onClick={()=>{
									if (filterStatus.length > 0) {
										setFilterStatus([])
									} else {
										setFilterStatus([...STATES])
									}
								}}
								key={`state_all`}
								type="radio"
								id={`state_all`}
								label="ALL"
							/>
							
							{STATES.map(state => {
								return <Form.Check // prettier-ignore
								checked={filterStatus.indexOf(state) >= 0}
								style={styles.input}
								onClick={()=>{
									if (filterStatus.indexOf(state) >= 0) {
										setFilterStatus(filterStatus.filter(fa => fa !== state))
									} else {
										setFilterStatus([...filterStatus, state])
									}
								}}
								key={`states_${state}`}
								type="radio"
								id={`states_${state}`}
								label={STATE.getName(state)}
							/>
							})}
							</Col>
						</Row>
						<hr></hr>
						<Row>
							<Col style={styles.flexGroup}><Form.Check // prettier-ignore
								checked={filterMystic.length > 0}
								style={styles.input}
								onClick={()=>{
									if (filterMystic.length > 0) {
										setFilterMystic([])
									} else {
										setFilterMystic([...MYSTICS])
									}
								}}
								key={`mystic_all`}
								type="radio"
								id={`mystic_all`}
								label="ALL"
							/>
							{MYSTICS.map(mystic => {
								return <Form.Check // prettier-ignore
								checked={filterMystic.indexOf(mystic) >= 0}
								style={styles.input}
								onClick={()=>{
									if (filterMystic.indexOf(mystic) >= 0) {
										setFilterMystic(filterMystic.filter(fa => fa !== mystic))
									} else {
										setFilterMystic([...filterMystic, mystic])
									}
								}}
								key={`mystic_${mystic}`}
								type="radio"
								id={`mystic_${mystic}`}
								label={`${mystic}${STAR_HOLLOW}`}
							/>
							})}
							</Col>
						</Row>
						<hr></hr>
						<Row>
							<Col style={styles.flexGroup}><Form.Check // prettier-ignore
								checked={filterAtk.length > 0}
								onClick={()=>{
									if (filterAtk.length > 0) {
										setFilterAtk([])
									} else {
										setFilterAtk([...BULLETS])
									}
								}}
								style={styles.input}
								key={`atk_all`}
								type="radio"
								id={`atk_all`}
								label="ALL"
							/>
							{BULLETS.map(type => {
								return <Form.Check // prettier-ignore
								style={styles.input}
								checked={filterAtk.indexOf(type) >= 0}
								onClick={()=>{
									if (filterAtk.indexOf(type) >= 0) {
										setFilterAtk(filterAtk.filter(fa => fa !== type))
									} else {
										setFilterAtk([...filterAtk, type])
									}
								}}
								key={`atk_${type}`}
								type="radio"
								id={`atk_${type}`}
								label={`${type}`}
							/>
							})}
							</Col>
						</Row>
						<hr></hr>
						<Row>
							<Col style={styles.flexGroup}><Form.Check // prettier-ignore
								checked={filterDef.length > 0}
								onClick={()=>{
									if (filterDef.length > 0) {
										setFilterDef([])
									} else {
										setFilterDef([...ARMORS])
									}
								}}
								style={styles.input}
								key={`def_all`}
								type="radio"
								id={`def_all`}
								label="ALL"
							/>
							{ARMORS.map(type => {
								return <Form.Check // prettier-ignore
								checked={filterDef.indexOf(type) >= 0}
								style={styles.input}
								onClick={()=>{
									if (filterDef.indexOf(type) >= 0) {
										setFilterDef(filterDef.filter(fa => fa !== type))
									} else {
										setFilterDef([...filterDef, type])
									}
								}}
								key={`def_${type}`}
								type="radio"
								id={`def_${type}`}
								label={`${type}`}
							/>
							})}
							</Col>
						</Row>
						<hr></hr>
						<Row>
							<Col style={styles.flexGroup}><Form.Check // prettier-ignore
								checked={filterTactic.length > 0}
								onClick={()=>{
									if (filterTactic.length > 0) {
										setFilterTactic([])
									} else {
										setFilterTactic([...TACTICS])
									}
								}}
								key={`tactic_all`}								style={styles.input}

								type="radio"
								id={`tactic_all`}
								label="ALL"
							/>
							{TACTICS.map(type => {
								return <Form.Check // prettier-ignore
																style={styles.input}

								checked={filterTactic.indexOf(type) >= 0}
								onClick={()=>{
									if (filterTactic.indexOf(type) >= 0) {
										setFilterTactic(filterTactic.filter(fa => fa !== type))
									} else {
										setFilterTactic([...filterTactic, type])
									}
								}}
								key={`role_${type}`}
								type="radio"
								id={`role_${type}`}
								label={`${type}`}
							/>
						})}
						</Col>
						</Row>
						<hr></hr>
						<Row>
							<Col style={styles.flexGroup}><Form.Check // prettier-ignore
								checked={filterFormation.length > 0}
								onClick={()=>{
									if (filterFormation.length > 0) {
										setFilterFormation([])
									} else {
										setFilterFormation([...FORMATION])
									}
								}}								
								style={styles.input}
								key={`formation_all`}
								type="radio"
								id={`formation_all`}
								label="ALL"
							/>
							{FORMATION.map(type => {
								return <Form.Check // prettier-ignore
								checked={filterFormation.indexOf(type) >= 0}
								style={styles.input}
								onClick={()=>{
									if (filterFormation.indexOf(type) >= 0) {
										setFilterFormation(filterFormation.filter(fa => fa !== type))
									} else {
										setFilterFormation([...filterFormation, type])
									}
								}}
								key={`formation_${type}`}
								type="radio"
								id={`formation_${type}`}
								label={`${type}`}
							/>
							})}
							</Col>
						</Row>
						<hr></hr>
						<Row><Col><h5 className="text-pink">Import Soon?</h5></Col></Row>
						<Row><Col><h5 className="text-pink">Sorting</h5></Col></Row>
						<Row><Col style={styles.flexGroup}>
							{["Release","Name", "ID"].map(type => {
								return <Form.Check // prettier-ignore
								checked={sortBy === type}
								style={styles.input}
								onClick={()=>{
									setSortBy(type as SORT_BY)
								}}
								key={`sort_${type}`}
								type="radio"
								id={`sort_${type}`}
								label={`${type}`}
							/>
							})}
						</Col></Row>
						<Row><Col><h5 className="text-pink">Grouping</h5></Col></Row>
						<Row><Col style={styles.flexGroup}>
							{["None", "Availability", "State", "Mystic", "Role", "Formation", "Bullet", "Armor"].map(type => {
								return <Form.Check // prettier-ignore
								checked={groupBy === type}
								style={styles.input}
								onClick={()=>{
									setGroupBy(type as GROUP_BY)
								}}
								key={`group_${type}`}
								type="radio"
								id={`group_${type}`}
								label={`${type}`}
							/>
							})}
						</Col></Row>
						<Row>
							<Col>
								<Button 
									variant="violet"
									onClick={() => {
										for(const student of display) {
											setStudentState(student.Id.toString(), STATE.SELECTED);
										}
									}}
								>Select All Visible</Button>
								<Button 
									variant="violet"
									onClick={() => {
										for(const student of display) {
											setStudentState(student.Id.toString(), STATE.UNSELECTED);
										}
									}}
								>Deselect All Visible</Button>
								<Button 
									variant="violet"
									onClick={() => {
										for(const student of display) {
											setStudentState(student.Id.toString(), STATE.BLUE);
										}
									}}
								>Set All Visible to {STATE.getName(STATE.BLUE)}</Button>
								<Button 
									variant="violet"
									onClick={() => {
										for(const student of display) {
											setStudentState(student.Id.toString(), STATE.BLACK);
										}
									}}
								>Set All Visible to {STATE.getName(STATE.BLACK)}</Button>
							</Col>
						</Row>
					</AccordionBody>
				</Accordion.Item>
			</Accordion>
		</Col>
	</Row>
	<Row><Col>
		<Alert dismissible>
			Tips: 
			<ul>
				<li>Click or Tap to toggle between {STATE.getName(STATE.UNSELECTED)} and {STATE.getName(STATE.SELECTED)}</li>
				<li>Hold <span className="text-pink">CTRL</span> while clicking to set to {STATE.getName(STATE.SELECTED)}</li>
				<li>Hold <span className="text-pink">SHIFT</span> while clicking to set to {STATE.getName(STATE.BLUE)}</li>
				<li>Hold <span className="text-pink">ALT</span> while clicking to set to {STATE.getName(STATE.BLACK)}</li>
				<li>Right Click or Long Press to open context menu and select which state to set</li>
			</ul>
		</Alert>
	</Col></Row>
	<Row id="roster" className="bg-body-secondary">
		<Col>
			<Row>
				<Col>
					<h1 className="text-pink">{title}</h1>
					{noteUnselected?.length > 0 && <h4 className="text-pink">Unselected: {noteUnselected}</h4>}
					{notePink?.length > 0 && <h4 className="text-pink">Pink: {notePink}</h4>}
					{noteBlue?.length > 0 && <h4 className="text-pink">Blue: {noteBlue}</h4>}
					{noteBlack?.length > 0 && <h4 className="text-pink">Black: {noteBlack}</h4>}
				</Col>
			</Row>
			<Row style={{...styles.container,display:"flex"}} className="noselect responsive-font full-list">
				{Object.entries(groups).map(([group, students]) => {
					return (<>
						{!!group && <Row><Col><h5 className="text-pink">{group}</h5></Col></Row>}
						{students.map(student => {
							const id = student.Id.toString();
							const studentState = getCategoryState(id)[parseInt(id.substring(2))] as STATE;
							return <Col className="student" style={{
								opacity: studentState === STATE.UNSELECTED ? 0.2 : 1,
							}} 
							onContextMenu={(e) => {
								e.preventDefault();
								setContextMenuPos({
									x: e.pageX,
									y: e.pageY,
								});
								setContextStudent(student)
							}}
							onClick={(e) => {
								if (e.ctrlKey) {
									setStudentState(id, STATE.SELECTED);
								} else if (e.shiftKey) {
									setStudentState(id, STATE.BLUE);
								} else if (e.altKey) {
									setStudentState(id, STATE.BLACK);
								} else {
									toggleStudent(id)
								}
							}}><StudentRenderer nameplate={STATE.getColor(studentState)} bare model={Student.fromId(id)} /></Col>
						})}
						<br></br>
					</>);
				})}
			</Row>
			<Row>
				<Col>
					<MyBrand/>
				</Col>
			</Row>
		</Col>
	</Row>
	<Row id="screenshot-roster" hidden={!isPic} ref={rosterDiv} className="bg-body-secondary" style={{minWidth: `${screenshotWidth}px`, width: `${screenshotWidth}px`
	}}>
		<Col>
			<Row>
				<Col>
					<h1 className="text-pink">{title}</h1>
					{noteUnselected?.length > 0 && <h4 className="text-pink">Unselected: {noteUnselected}</h4>}
					{notePink?.length > 0 && <h4 className="text-pink">Pink: {notePink}</h4>}
					{noteBlue?.length > 0 && <h4 className="text-pink">Blue: {noteBlue}</h4>}
					{noteBlack?.length > 0 && <h4 className="text-pink">Black: {noteBlack}</h4>}
				</Col>
			</Row>
			<Row style={{...styles.container,display:"flex"}} className="responsive-font full-list">
				{Object.entries(groups).map(([group, students]) => {
					return (<>
						{!!group && <Row><Col><h3 className="text-pink">{group}</h3></Col></Row>}
						
						{students.map(student => {
							const id = student.Id.toString();
							const studentState = getCategoryState(id)[parseInt(id.substring(2))] as STATE;
							return <Col className="student" style={{
								opacity: studentState === STATE.UNSELECTED ? 0.2 : 1,
							}}>
								<StudentRenderer disableSchale nameplate={STATE.getColor(studentState)} bare model={Student.fromId(id)} />
							</Col>
						})}
						<br></br>
					</>);
				})}
			</Row>
			<Row style={{textAlign: "center", marginTop: "0.2em"}}><Col><CurrentQR size={256}></CurrentQR></Col></Row>
			<Row>
				<Col>
					<MyBrand/>
				</Col>
			</Row>
		</Col>
	</Row>
	<StudentContextMenu />
	<MyLoadingSpinner overlay isLoading={isPic} />
	</div>);
}
